import { render, staticRenderFns } from "./spOrder.vue?vue&type=template&id=17ab6732&scoped=true&"
import script from "./spOrder.vue?vue&type=script&lang=js&"
export * from "./spOrder.vue?vue&type=script&lang=js&"
import style0 from "./spOrder.vue?vue&type=style&index=0&id=17ab6732&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ab6732",
  null
  
)

export default component.exports